import React from 'react';
import { ShieldCheck, Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, Award, Lock } from 'lucide-react';
interface FooterProps {
  onNavigate: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-slate-900 text-slate-200 pt-20 pb-10" data-id="element-95">
      <div className="container mx-auto px-4 md:px-6" data-id="element-96">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 mb-16" data-id="element-97">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-98">
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => onNavigate('home')} data-id="element-99">
              <ShieldCheck className="h-8 w-8 text-blue-500" data-id="element-100" />
              <span className="text-2xl font-bold text-white" data-id="element-101">
                SmartProtect<span className="text-blue-500" data-id="element-102">24</span>
              </span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-103">
              Ihr Premium-Partner für digitale Versicherungs- und
              Finanzlösungen. Sicher, transparent und jederzeit für Sie da.
            </p>
            <div className="flex space-x-4 pt-2" data-id="element-104">
              <a href="#" className="bg-slate-800 p-2 rounded-full text-slate-400 hover:text-white hover:bg-blue-600 transition-all" data-id="element-105">
                <Facebook className="h-4 w-4" data-id="element-106" />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded-full text-slate-400 hover:text-white hover:bg-blue-600 transition-all" data-id="element-107">
                <Twitter className="h-4 w-4" data-id="element-108" />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded-full text-slate-400 hover:text-white hover:bg-blue-600 transition-all" data-id="element-109">
                <Instagram className="h-4 w-4" data-id="element-110" />
              </a>
              <a href="#" className="bg-slate-800 p-2 rounded-full text-slate-400 hover:text-white hover:bg-blue-600 transition-all" data-id="element-111">
                <Linkedin className="h-4 w-4" data-id="element-112" />
              </a>
            </div>
          </div>

          {/* Links Column 1 */}
          <div data-id="element-113">
            <h3 className="mb-6 text-lg font-semibold text-white" data-id="element-114">
              Unternehmen
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-115">
              <li data-id="element-116">
                <button onClick={() => onNavigate('ueber-uns')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-117">
                  Über uns
                </button>
              </li>
              <li data-id="element-118">
                <button onClick={() => onNavigate('beratung')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-119">
                  Karriere
                </button>
              </li>
              <li data-id="element-120">
                <button onClick={() => onNavigate('kontakt')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-121">
                  Presse
                </button>
              </li>
              <li data-id="element-122">
                <button onClick={() => onNavigate('home')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-123">
                  Partnerprogramm
                </button>
              </li>
            </ul>
          </div>

          {/* Links Column 2 */}
          <div data-id="element-124">
            <h3 className="mb-6 text-lg font-semibold text-white" data-id="element-125">Service</h3>
            <ul className="space-y-3 text-sm" data-id="element-126">
              <li data-id="element-127">
                <button onClick={() => onNavigate('rechner')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-128">
                  Versicherungsrechner
                </button>
              </li>
              <li data-id="element-129">
                <button onClick={() => onNavigate('app')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-130">
                  SmartProtect App
                </button>
              </li>
              <li data-id="element-131">
                <button onClick={() => onNavigate('faq')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-132">
                  Hilfe & FAQ
                </button>
              </li>
              <li data-id="element-133">
                <button onClick={() => onNavigate('beratung')} className="text-slate-400 hover:text-blue-400 transition-colors" data-id="element-134">
                  Persönliche Beratung
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-135">
            <h3 className="mb-6 text-lg font-semibold text-white" data-id="element-136">Kontakt</h3>
            <ul className="space-y-4 text-sm" data-id="element-137">
              <li className="flex items-start gap-3 group" data-id="element-138">
                <div className="p-2 bg-slate-800 rounded-lg group-hover:bg-blue-600 transition-colors" data-id="element-139">
                  <MapPin className="h-4 w-4 text-white" data-id="element-140" />
                </div>
                <span className="text-slate-400" data-id="element-141">
                  Premium Plaza 1<br data-id="element-142" />
                  10115 Berlin
                </span>
              </li>
              <li className="flex items-center gap-3 group" data-id="element-143">
                <div className="p-2 bg-slate-800 rounded-lg group-hover:bg-blue-600 transition-colors" data-id="element-144">
                  <Phone className="h-4 w-4 text-white" data-id="element-145" />
                </div>
                <span className="text-slate-400" data-id="element-146">+49 (0) 30 12345678</span>
              </li>
              <li className="flex items-center gap-3 group" data-id="element-147">
                <div className="p-2 bg-slate-800 rounded-lg group-hover:bg-blue-600 transition-colors" data-id="element-148">
                  <Mail className="h-4 w-4 text-white" data-id="element-149" />
                </div>
                <span className="text-slate-400" data-id="element-150">
                  service@smartprotect24.de
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="border-t border-slate-800 py-8 mb-8" data-id="element-151">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-152">
            <div className="flex items-center gap-2" data-id="element-153">
              <Award className="h-6 w-6 text-amber-500" data-id="element-154" />
              <span className="font-semibold text-slate-300" data-id="element-155">TÜV Geprüft</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-156">
              <Lock className="h-6 w-6 text-blue-500" data-id="element-157" />
              <span className="font-semibold text-slate-300" data-id="element-158">
                SSL Verschlüsselung
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-159">
              <ShieldCheck className="h-6 w-6 text-green-500" data-id="element-160" />
              <span className="font-semibold text-slate-300" data-id="element-161">
                DSGVO Konform
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-162">
              <Award className="h-6 w-6 text-purple-500" data-id="element-163" />
              <span className="font-semibold text-slate-300" data-id="element-164">
                Testsieger 2025
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500" data-id="element-165">
          <p data-id="element-166">
            &copy; {new Date().getFullYear()} SmartProtect24. Alle Rechte
            vorbehalten.
          </p>
          <div className="flex space-x-6" data-id="element-167">
            <a href="#" className="hover:text-white transition-colors" data-id="element-168">
              Impressum
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-169">
              Datenschutz
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-170">
              AGB
            </a>
          </div>
        </div>
      </div>
    </footer>;
}